export const resources = {
  Loading_Message: 'Please wait while we are verifying your request.',
  en: {
    Checkin: {
      LAST_NAME: 'Last Name*',
      REQ_LAST_NAME: 'Last Name is required*',
      GUARD_TITLE: 'Intake paperwork completed by guardian or other legal patient representative',
      GUARD_INFO: 'Guardian Information',
      RELATION_PAT: 'Relation to Patient*',
      REQ_RELATION_PAT: 'Relation to Patient is required*',
      SHOULD_VALID_LAST_NAME: 'Last name must be valid',
      HEADING: 'Click below to check-in',
      CLINIC_ADDRESS: 'Clinic Address',
      DATE: 'Date',
      CHECKIN_BUTTON: 'Check in',
      LOWER_MODEL_HEADING: 'We believe in the power of the personal touch.',
      PHYSICAL_THERAPY: 'Physical Therapy',
      OCCUPATIONAL_THERAPY: 'Occupational Therapy',
      SPEACH_THERAPY: 'Speech Therapy',
      ENTER_YOUR_DETAILS: 'Enter your details',
      DOB_PLACEHOLDER: 'Date of Birth (mm/dd/yyyy) *',
      MOBILE_PLACEHOLDER: 'Mobile Number *',
      VALIDATE: 'Validate',
      NO_DATA_FOUND: 'No data found. Please proceed to front desk',
      YES: 'Yes, Update',
      NO: 'Nothing has changed',
      WELCOME: 'Welcome',
      INFO_CHANGED_TEXT: 'Has any of the following information changed?',
      PHONE_NUMBER: 'Phone Number',
      EMAIL: 'Email',
      ADDRESS: 'Address',
      INSURANCE: 'Insurance',
      PLEASE_WAIT: 'Please wait while we are verifying your request.',
      ERROR: 'Something went wrong. Please try again later.',
      CHECKING: 'Checkin',
      DOB_REQUIRED: 'Date of Birth is required',
      PHONE_REQUIRED: 'Phone Number is required.',
      PHONE_VALID_NUMBER: 'Please enter a valid mobile number',
    },
    PatientInformation: {
      FIRST_NAME: 'First Name *',
      LAST_NAME: 'Last Name *',
      PREFERED_NAME: 'Prefered Name',
      HEIGHT_INCH: 'Height Inch',
      HEIGHT_FEET: 'Height Feet',
      WEIGHT: 'Weight (lbs)',
      CITY: 'City',
      CITY_REQ: 'City is required',
      STATE: 'State',
      STATE_REQ: 'State is required',
      ZIP: 'Zip *',
      ADDRESS1: 'Address 1 *',
      ADDRESS2: 'Address 2',
      PHONENUMBER: 'Phone Number *',
      EMAIL: 'Email Address *',
      HOW_DID_YOU_HEAR_ABOUT_CORA: 'How did you hear about CORA',
      FROM_WHERE_DID_YOU_HEAR_ABOUT_CORA: 'From where did you hear about CORA?',
      PRIMARY_CARE_FIRST_NAME: 'First Name',
      PRIMARY_CARE_LAST_NAME: 'Last Name',
      PRIMARY_CARE_PHONENUMBER: 'Phone Number',
      EMERGENCY_CONTACT_RELATIONSHIP: 'Relationship',
      EMERGENCY_CONTACT_FIRST_NAME: 'First Name *',
      EMERGENCY_CONTACT_LAST_NAME: 'Last Name *',
      EMERGENCY_CONTACT_PHONENUMBER: 'Phone Number *',
      ARE_YOU_MEDICARE_PATIENT: 'Are you a medicare patient?',
      YES: 'Yes',
      NO: 'No',
      WHERE_DID_YOU_HAVE_THE_INCIDENT: 'Where did you have the incident?',
      WORK: 'Work',
      AUTO_ACCIDENT: 'Auto Accident',
      NEITHER: 'Neither',
      WORK_EMPLOYER_NAME: 'Employer Name *',
      WORK_PHONE_NUMBER: 'Phone Number',
      WORK_CITY: 'City *',
      WORK_ADDRESS1: 'Address 1',
      WORK_ADDRESS2: 'Address 2',
      WORK_WHAT_IS_YOUR_REGULAR_JOB: 'What is your regular job?',
      WORK_STATUS_OF_JOB: 'Status of Job?',
      AUTO_ACCIDENT_INSURANCE_COMPANY: 'Auto Insurance Company*',
      AUTO_ACCIDENT_PHONE_NUMBER: 'Phone Number',
      AUTO_ACCIDENT_ATTORNEY_PHONE_NUMBER: 'Attorney Phone Number',
      AUTO_ACCIDENT_ATTORNEY_FIRST_NAME: 'Attorney First Name',
      AUTO_ACCIDENT_ATTORNEY_LAST_NAME: 'Attorney Last Name',
      AUTO_ACCIDENT_HEALTH_INSURANCE_COMPANY: 'Health Insurance Company *',
      AUTO_ACCIDENT_HEALTH_INSURANCE_PHONE_NUMBER:
        'Health Insurance Phone Number',
      AUTO_ACCIDENT_NAME_OF_PRIMARY_INSURED: 'Name of primary insured',
      AUTO_ACCIDENT_ID_NUMBER: 'ID number',
      AUTO_ACCIDENT_DO_YOU_HAVE_LETTER_OF_EXHUASTION:
        'Do you have a letter of exhaustion from your auto carrier?',
      AUTO_ACCIDENT_LETTER_OF_EXHUASTION_COPY: 'Letter Of Exhaustion Copy',
      AUTO_ACCIDENT_NOT_SURE: 'Not Sure',
      CONTACT_HEADER: 'Contact Information',
      CONTACT_INFO:
        'By submitting this form and signing up for texts, you consent to receive CORA Physical Therapy text messages (e.g. Registration reminders, enrollment information, and general updates) from CORA Physical Therapy at the number provided, including messages sent by autodialer. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). Reply HELP for help.',
      PRIMARY_CARE_HEADING: 'Primary Care Physician',
      EMERGENCY_CONTACT_HEADING: 'Emergency Contact',
      CONTINUE_MEDICAL_HISTORY_BUTTON: 'Continue, To Medical History',
      PATINET_INFO: 'Patient Information',
      FIRST_NAME_REQ: 'First name is required.',
      VALID_FIRST_NAME: 'Please enter a valid first name',
      LAST_NAME_REQ: 'Last name is required.',
      VALID_LAST_NAME: 'Please enter a valid last name',
      VALID_PREFERRED_NAME: 'Please enter a valid preferred Name',
      HEIGHT_INCH_VALID: 'Please enter height between 0 to 11',
      WEIGHT_VALID: 'Please enter a valid Weight',
      ZIP_REQUIRED: 'Zip is required',
      ADD1_REQ: 'Address 1 is required',
      PHONE_REQ: 'Phone number is required',
      PHONE_VALID: 'Please enter a valid phone number',
      EMAIL_VALID: 'Please enter email address in correct format',
      NAME_WHO_REFERRED_YOU: 'Name/Title of person who referred you',
      VALID_NAME: 'Please enter a valid name',
      NAME_REQ: 'Name is required',
      VALID_JOB: 'Please enter a valid job',
      AUTO_INSURANCE_REQ: 'Auto Insurance is required.',
      HEALTH_INSURANCE_REQ: 'Health Insurance is required.',
      CAPTURE_WEBCAMERA: 'Capture through webcamera',
      CAPTURE_CAMERA: 'Capture by Camera',
      UPLOAD_FROM_PC: 'Upload from your computer drive',
      RETAKE: 'Re-take',
      CONT_UPLOAD_DOCS_BUTTON: 'Continue, to upload documents',
      UPLOADED: 'Uploaded',
    },
    MedicalHistory: {
      MEDICAL_HISTORY: 'Medical History',
      SKIP_TEXT: 'Skip This Step',
      HEART_PROBLEMS: 'Heart Problems',
      PREGNANT: 'Pregnant',
      CANCER: 'Cancer',
      PACE_MAKERS: 'Pace Makers',
      OSTEO: 'Osteoporosis',
      DIABETES: 'Diabetes',
      ASTHMA: 'Asthma',
      STROKE: 'Stroke',
      HIGHBP: 'High Blood Pressure',
      SMOKING: 'Smoking',
      SEIZURES: 'Seizures',
      HIV_AIDS: 'HIV/AIDS',
      CHECKBOX_HEADING:
        'Do you have/had any of the following medical illness/concerns?',
      MEDICATIONS_HEADING: 'Medications and allergies information',
      MEDICATIONS_LABEL: 'medications,',
      MEDICATIONS_PLACEHOLDER: 'Darvocet, 100 mg, every 6 hours',
      DOYOUHAVEALLERGY: 'Do you have any allergies?',
      YES: 'Yes',
      NO: 'No',
      LIST_ALLERGIES: 'Anotar Alergias *',
      CP_COMPLAINT: 'Please describe your chief physical complaint',
      CP_COMPLAINT_PLACEHOLDER: 'Chief physical complaint',
      HOW_WHEN_HAPPENED: 'How/When it happened',
      LAST_5YRS: 'What other injuries have you had in the last five years?',
      HAVE_PREVIOUS_INJURY:
        'Have you had previous therapy for the problem/injuries?',
      CON_UPLOAD_DOCS_BUTTON: 'Continue, To Upload Documents',
      BACK: 'Back',
      HELPFUL: 'If yes, was it helpful?',
      ALERGIES_REQUIRED: 'Allergies are required.',
    },
    MedicarePatient: {
      MEDICARE_HEADING_1:
        'In order to determine your eligibility for outpatient therapy services please answer the following questions',
      MEDICARE_HEADING_2:
        'IS A HOME HEALTH REPRESENTATIVE, NURSE, AIDE, THERAPIST OR ANYONE OTHER THAN A FAMILY MEMBER CURRENTLY ASSISTING YOU IN YOUR HOME WITH',
      PHYSICAL_OCCUPATIONAL_OR_SPEECH_THERAPY:
        'Physical, occupational or speech therapy',
      WOUND_CARE: 'Wound care',
      INJECTIONS_OR_MEDICATIONS: 'Injections or medications',
      BATHING_OR_PERSONAL_CARE: 'Bathing or personal care',
      IV_CARE: 'IV care',
      HOME_HEALTH_REPRESENTATIVE:
        'Has a Home Health Representative, Nurse, Aide, Therapist or anyone other than a family member assisted you in your home with services in the past 30 days',
      IF_YOU_ANS_YES:
        'If you answered “YES” to any of the questions above, you MAY NOT be eligible for outpatient therapy services as determined by Medicare’s guidelines. In order to qualify for our services you will need to be discharged completely from all home care services, which is your responsibility. A copy of the Medicare ABN form provided for you to read and sign. You understand that if claims are denied you will be responsible for these charges.',
      CONTINUE_TO_REVIEW_FORM: 'Continue, To Review Form',
      BACK: 'Back',
      YES: 'Yes',
      NO: 'No',
    },
    UploadDocs: {
      FILE_SMALLER_THAN_25MB: 'File should not be greater than 25MB',
      PDF_OR_IMG_ALLOWED: 'You can only upload a PDF file or an image.',
      TAKE_PHOTO: 'Take Photo',
      UPLOAD_CAPTIAL_U: 'Upload',
      UPLOAD_SMALL_U: 'upload',
      CAPTURE_WEBCAMERA: 'Capture through webcamera',
      CAPTURE_CAMERA: 'Capture by Camera',
      UPLOAD_FROM_PC: 'Upload from your computer drive',
      RETAKE: 'Re-take',
      NEXT: 'Next',
      SKIP: 'Skip this step',
      SELECT_DOC_FIRST: 'Please select document type first',
      SELECT_DOC_TYPE: 'Select Document Type',
      UPLOAD_TEXT: 'We are happy to collect your photo ID and insurance card at the front desk if you are unable to upload.  Thank you!',
    },
    ReviewPage: {
      REVIEW_HEADING: 'Please review your details',
      EDIT: 'Edit',
      PATIENT_INFORMATION: 'Patient Information',
      LETTER_OF_EXC_COPY: 'Letter Of Exhaustion Copy',
      MEDICAL_INFORMATION: 'Medical Information',
      MEDICARE_FORM: 'Medicare Patient',
      UPLOAD_DOCS: 'Upload Documents',
      UPLOAD_WORD: 'Upload',
      PRESCRIPTION: 'Prescription',
      NEXT: 'Next',
      BACK: 'Back',
      SELECT_DOC_TYPE: 'Select Document Type',
    },
    Signature: {
      FIELD_REQ: 'Some fields are required, please fill and continue',
      SIGNATURE: 'Signature',
      I_AGREE_TO_THE: 'I agree to the',
      AND: 'and',
      AND_THE: 'and the',
      ACK_OF_RECEIPT:
        'acknowledgement of receipt of notice of privacy practices and release authorization ',
      AUTH_CONSENT: 'authorization consent for care and treatment',
      CAUSE_OF_ACTION: 'assignment of cause of action',
      FINANCIAL_RESP: 'financial responsibility',
      T_AND_C: 'terms and conditions',
      PRIVACY_POLICY: 'privacy policy',
      SUBMIT: 'Submit',
      BACK: 'Back',
      RECEIPT_ACK_MODAL_TEXT_PART_1:
        'I certify that I have received a copy of CORA Physical Therapy’s Notice of Privacy Practices. The Notice of Privacy Practices describes the types of uses and disclosures of my protected health information that might occur in my treatment, payment of my bills or in the performance of CORA Physical Therapy health care operations. The Notice of Privacy Practices also describes my rights and CORA Physical Therapy’s duties with respect to my protected health information. The Notice of Privacy Practices is also posted in the Front Desk area and on CORA Physical Therapy website at www.coraphysicaltherapy.com. CORA Physical Therapy reserves the right to change the privacy practices that are described in the Notice of Privacy Practices. I may obtain a revised Notice of Privacy Practices by calling the office and requesting a revised copy be sent in the mail, asking for one at the time of my next appointment or accessing CORA Physical Therapy’s website. By clicking in the box below, you acknowledge that you have received or been given any opportunity to receive the CORA Physical Therapy Notice of Privacy Practices. have received or been given an opportunity to receive CORA Physical Therapy’s Notice of Privacy Practices.',
      RECEIPT_ACK_MODAL_TEXT_PART_2:
        'AUTHORIZATION FOR THE USE OR DISCLOSURE OF HEALTH INORMATION FROM CORA PHYSICAL THERAPY',
      RECEIPT_ACK_MODAL_TEXT_PART_3:
        'By signing this Authorization Form, I understand that I am giving my authorization to CORA Physical Therapy’s designated medical record custodians, database custodians, central billing / collections office personnel to use and/or disclose my protected health information (PHI), as described in more detail in the paragraphs below, to the following person(s) or organization(s). If this authorization is for any purpose other than the release of medical records for personal reasons, please state the purpose of the authorization to release PHI below: I may revoke this authorization at any time by notifying CORA Physical Therapy in writing to Attention Collections Manager, P.O. Box 150, Lima, OH 45802 of my intent to revoke this authorization. However, I also understand that such a revocation will not have any effect on any information already used or disclosed by CORA Physical Therapy before CORA Physical Therapy received my written notice of revocation. Unless earlier revoked, this authorization will expire on the 180th day of the signing (or as otherwise specified). ',
      RECEIPT_ACK_MODAL_TEXT_PART_4:
        'I understand that I have the right to: inspect or copy the PHI to be used or disclosed as permitted under Federal or State law; refuse to sign this authorization; and receive a copy of this authorization. If I am requesting information for myself or for a third party, a reasonable and appropriate fee may be assessed for copying the information. I have read the above information and authorize the disclosure of my information by CORA Physical Therapy for the purpose described herein.',
      RECEIPT_ACK_MODAL_TEXT_PART_5:
        'By clicking in the box below, you acknowledge that you have read and agree to the terms of this authorization',
      TREATMENT_ACK_MODAL_TEXT:
        "I hereby give my consent to the facility and/or treating physicians and their agents to release all records, including via electronic transmittal, prepared in the course of my treatment, to any entity which provides financial assistance for my health care, including, but not limited to, insurance companies and their agents, self-insured employers or public welfare agencies. I certify that the information given by me in applying for payment under Title XVII of the social security act is correct. I authorize any holder of medical or other information about me to release to the Social Security Administration and/or the Medicare program or its intermediaries or carriers, or to the professional standards review organizations any information needed for this or a related Medicare claim. I understand that by signing this form, records of a confidential nature, such as Social Security Numbers and those for HIV testing, AIDS or AIDS related condition, psychiatric problems or substance abuse, will be released to the entities providing financial assistance for my health care. This release includes disclosing data to local, state, federal, other entities for routine operational purpose of regulatory, legal or contract compliance, accreditation, peer review, quality improvement, continuity of care, or processing appeals for claims denials. I also understand that I may revoke this consent at any time and without revocation and that it will expire one year from the date of discharge. I acknowledge that I have been provided and given the opportunity to review the Facility's Information regarding patient's rights and responsibilities. I hereby authorize CORA Physical Therapy to provide care and treatment under my physician's direction or as allowed under my state’s direct access provisions",
      ACTION_ACK_MODAL_TEXT_1:
        'I here by assign by this instrument all rights and causes of action in tort, in contract and the laws of the state where I am being treated against the personal injury protection carrier, if any for its failure to pay for services rendered unto me by Assignee in relation to my accident that occurred on',
      ACTION_ACK_MODAL_TEXT_2:
        'Please call our Billing Office if you have any questions on your account or if you are unable to pay your balance in full they will be able to discuss payment arrangements with you. The number is 866-493-9410',
      FINANCIAL_ACK_MODAL_TEXT: `I understand that my insurance contract is between me,
      my employer (if applicable) and the insurance carrier
      and that CORA Physical Therapy (CORA) is not a party
      to that contract. I understand that, as a matter of
      process, CORA will contact my insurance carrier
      (including Medicare) to verify my benefits and the
      services covered under my insurance contract. I
      acknowledge that providing accurate insurance and
      other information is critical to determining my
      eligibility under my insurance contract. I understand
      that CORA is verifying benefits as a courtesy and that
      ultimately it is my responsibility to understand what
      is covered and required under my policy. I understand
      that CORA will bill my insurance carrier (including
      Medicare) for services rendered upon verification of
      coverage by my insurance carrier. I understand that
      verification of benefits is not a guarantee of payment
      and my financial responsibility is subject to change.
      If my insurance carrier fails to render payment for
      services rendered, I hereby personally guarantee
      payment for medical care and services rendered. If my
      insurance carrier does not remit payments, including
      if I am denied benefits under workers compensation, I
      understand that I will be responsible for the balance
      due in full. I understand that I am responsible for
      paying my co-payments, co-insurance (including
      co-insurance from Medicare) and deductibles at the
      time of service which I acknowledge may be an estimate
      at that time. Further, I understand that federal and
      state laws and insurance carrier contracts prevent
      CORA from adjusting, writing off or waiving
      co-payments, co-insurance (including co-insurance from
      Medicare) and deductibles. I also understand that I am
      responsible for any balance due after payment by my
      insurance carrier. Pursuant to the assignment of
      benefits herein; I hereby request that my insurance
      carrier make payment directly to CORA for all services
      rendered by this facility. If my current policy
      prohibits direct payment to CORA, I hereby instruct
      and direct my insurance carrier to make the check out
      in my name but send the check to: CORA Physical
      Therapy, P.O. Box 150, Lima, OH 45802. If my insurance
      carrier makes payments to me I agree to immediately
      pay over these funds to CORA. I also authorize CORA to
      deposit check received on my account when made out to
      me. I understand and agree that if I fail to make any
      of the payments for which I am responsible in a timely
      manner, I will be responsible for all costs of
      collecting monies owed, including court costs,
      collection agency fees and attorney fees.`,
    },
    Submission: {
      DOXYTEXT: 'Click here to start your telehealth appointment',
      LOGOUT: 'Log out',
      OR: 'OR',
      YOU_ARE_ALL_SET_WAYSTAR:
        'Please stop by the front desk to make your payment',
      PAYMENT: 'Click here to make payment online',
      ISSUE_IN_CLINIC:
        'There is an issue with the clinic you are trying to check in.',
      FOR_MORE_INFO:
        'For more information, please proceed to front desk or call us at',
      PROCEED_TO_FRONT_DESK: 'Please proceed to front desk',
      INFO_HAS_BEEN_SUBMITTED: 'Your information has been submitted',
      YOU_ARE_ALL_SET: 'Please stop by the front desk',
      WE_WILL_BE_RIGHT_TO_YOU:
        'Thank you.  Your acknowledgement has been sent.',
      BACK_TO_HOME: 'Back to Home',
    },
    VerificationOfBenefits: {
      REDO: 'REDO',
      SIGN_HERE: 'Sign here',
      HEADING: 'Verification Of Benefits',
      PART_1:
        'Your primary health insurance carrier had verified that you have a',
      PART_2: 'yearly deductible of which ',
      PART_3:
        ' has been met. After your deductible has been satisfied, your insurance carrier estimates your therapeutic benefits are covered at',
      PART_4: ' You have an estimated responsibility of ',
      PART_4_5: ' or ',
      PART_5: ' due at each visit.',
    },
    CheckInScreening: {
      QUESTION_1:
        'Have you tested positive for COVID-19 or experienced any of the following symptoms within the last 10 days:',
      QUESTION_1_DETAILS: `fever (99.5° or above), chills, muscle/body aches, runny nose/congestion,
      sore throat, cough, shortness of breath/difficulty breathing, nausea/vomiting, headache,
      diarrhea, fatigue, or new loss of taste and smell?`,
      QUESTION_2:
        'Within the last 10 days have you had close contact with or cared for someone who has confirmed COVID-19?',
      YES: 'Yes',
      NO: 'No',
      CLOSE_CONTACT_HEADER: 'Close contact is defined by the following:',
      CLOSE_CONTACT_1:
        'You were within 6 feet of an infected person for a cumulative total of 15 minutes or more over a 24-hour period starting from 2 days before illness onset.',
      CLOSE_CONTACT_2:
        'You provided care at home to someone who is sick with COVID-19.',
      CLOSE_CONTACT_3:
        'You had direct physical contact with the person (hugged or kissed them).',
      CLOSE_CONTACT_4: 'You shared eating or drinking utensils.',
      CLOSE_CONTACT_5:
        'They sneezed, coughed, or somehow got respiratory droplets on you.',
      PROCEED_TO_FRONT_DESK: 'Please proceed to the front desk',
      CONTINUE_CHECK_IN: 'Continue Check In',
    },
    patientForm: {
      VERIFY: 'Verify',
      INVALID_URL: 'Your provided url is invalid',
      SUCCESS: 'Verified',
      DANGER:
        "We couldn't locate your appointment, please contact the clinic at ",
      ENTER_BIRTH: 'Please enter birth date',
      GENDER: 'Gender',
      MALE: 'Male',
      FEMALE: 'Female',
      AMBIGUOUS: 'Ambiguous',
      SELECT_DATE: 'Select Date',
    },
  },
  spa: {
    patientForm: {
      VERIFY: 'Verificar',
      INVALID_URL: 'Su URL proporcionada no es válida',
      SUCCESS: 'Verificada',
      DANGER: 'No pudimos ubicar su cita, comuníquese con la clínica al ',
      ENTER_BIRTH: 'Por favor ingrese la fecha de nacimiento',
      GENDER: 'Género',
      MALE: 'Masculina',
      FEMALE: 'Femenina',
      AMBIGUOUS: 'Ambiguo',
      SELECT_DATE: 'Seleccione la fecha',
    },
    Checkin: {
      LAST_NAME: 'Apellido*',
      REQ_LAST_NAME: 'Se requiere apellido*',
      GUARD_TITLE: 'Documentation de ingreso completada por la persona responsable del paciente o representante legal del paciente',
      GUARD_INFO: 'Información de la personal responsible por el paciente',
      RELATION_PAT: 'Parentesco con el paciente*',
      REQ_RELATION_PAT: 'Se requiere Parentesco con el paciente',
      SHOULD_VALID_LAST_NAME: 'El apellido debe ser válido.',
      HEADING: 'Haga clic a continuación para registrarse',
      CLINIC_ADDRESS: 'Dirección de la clínica',
      DATE: 'Fecha',
      CHECKIN_BUTTON: 'Registrarse',
      LOWER_MODEL_HEADING: 'Creemos en el poder del toque personal.',
      PHYSICAL_THERAPY: 'Terapia física',
      OCCUPATIONAL_THERAPY: 'Terapia ocupacional',
      SPEACH_THERAPY: 'Terapia del lenguaje',
      ENTER_YOUR_DETAILS: 'Introduce tus detalles',
      DOB_PLACEHOLDER: 'Fecha de nacimiento (mm/dd/aaaa)*',
      MOBILE_PLACEHOLDER: 'Número de teléfono móvil',
      VALIDATE: 'Validar',
      NO_DATA_FOUND: 'Datos no encontrados. Diríjase a la recepción.',
      YES: 'Sí',
      NO: 'No',
      WELCOME: 'Bienvenidas',
      INFO_CHANGED_TEXT: '¿Cambió alguna de la información a continuación?',
      PHONE_NUMBER: 'Número de teléfono',
      EMAIL: 'Correo electrónico',
      ADDRESS: 'Dirección',
      INSURANCE: 'Seguro',
      PLEASE_WAIT: 'Espere mientras verificamos su solicitud.',
      ERROR: 'Algo salió mal. Por favor, inténtelo de nuevo más tarde.',
      CHECKING: 'Registrarse',
      DOB_REQUIRED: 'Se requiere fecha de nacimiento',
      PHONE_REQUIRED: 'Se requiere número de teléfono.',
      PHONE_VALID_NUMBER: 'Por favor, introduzca un número de móvil válido',
    },
    PatientInformation: {
      FIRST_NAME: 'Primer nombre *',
      LAST_NAME: 'Apellido *',
      PREFERED_NAME: 'Nombre Preferido',
      HEIGHT_INCH: 'Pulgadas de altura',
      HEIGHT_FEET: 'Pies de altura',
      WEIGHT: 'Peso libras',
      CITY: 'Ciudad',
      CITY_REQ: 'Se requiere ciudad',
      ZIP: 'Codigo Postal *',
      STATE: 'Estado',
      STATE_REQ: 'Estado requerido',
      ADDRESS1: 'Dirección 1 *',
      ADDRESS2: 'Dirección 2',
      PHONENUMBER: 'Número de teléfono *',
      EMAIL: 'Dirección de correo electrónico',
      HOW_DID_YOU_HEAR_ABOUT_CORA: '¿Cómo se enteró de CORA?',
      FROM_WHERE_DID_YOU_HEAR_ABOUT_CORA: '¿De dónde se enteró de CORA?',
      PRIMARY_CARE_FIRST_NAME: 'Primer nombre',
      PRIMARY_CARE_LAST_NAME: 'Apellido',
      PRIMARY_CARE_PHONENUMBER: 'Teléfono',
      EMERGENCY_CONTACT_RELATIONSHIP: 'Relación',
      EMERGENCY_CONTACT_FIRST_NAME: 'Primer nombre *',
      EMERGENCY_CONTACT_LAST_NAME: 'Apellido *',
      EMERGENCY_CONTACT_PHONENUMBER: 'Número de teléfono *',
      ARE_YOU_MEDICARE_PATIENT: '¿Es usted un paciente de Medicare?',
      YES: 'Sí',
      NO: 'No',
      WHERE_DID_YOU_HAVE_THE_INCIDENT: '¿Dónde tuviste el incidente?',
      WORK: 'Trabajar',
      AUTO_ACCIDENT: 'Accidente De Automóvil ',
      NEITHER: 'Ninguno',
      WORK_EMPLOYER_NAME: 'Nombre del empleador',
      WORK_PHONE_NUMBER: 'Número de teléfono',
      WORK_CITY: 'Ciudad',
      WORK_ADDRESS1: 'Dirección 1',
      WORK_ADDRESS2: 'Dirección 2',
      WORK_WHAT_IS_YOUR_REGULAR_JOB: '¿Cuál es tu trabajo habitual?',
      WORK_STATUS_OF_JOB: '¿Estado del trabajo?',
      AUTO_ACCIDENT_INSURANCE_COMPANY:
        'Información de Compañía de Seguro de automóvil',
      AUTO_ACCIDENT_PHONE_NUMBER: 'Número de teléfono',
      AUTO_ACCIDENT_ATTORNEY_PHONE_NUMBER: 'Número de teléfono del abogado',
      AUTO_ACCIDENT_ATTORNEY_FIRST_NAME: 'Nombre del abogado',
      AUTO_ACCIDENT_ATTORNEY_LAST_NAME: 'Apellido del abogado',
      AUTO_ACCIDENT_HEALTH_INSURANCE_COMPANY: 'Compañía de seguro de salud',
      AUTO_ACCIDENT_HEALTH_INSURANCE_PHONE_NUMBER:
        'Número de teléfono del seguro de salud',
      AUTO_ACCIDENT_NAME_OF_PRIMARY_INSURED: 'Nombre del asegurado primario',
      AUTO_ACCIDENT_ID_NUMBER: 'número de identificación',
      AUTO_ACCIDENT_DO_YOU_HAVE_LETTER_OF_EXHUASTION:
        '¿Tiene una carta de agotamiento de su compañía de auto',
      AUTO_ACCIDENT_LETTER_OF_EXHUASTION_COPY: 'Copia de carta de agotamiento',
      AUTO_ACCIDENT_NOT_SURE: 'No estoy seguro',
      CONTACT_HEADER: 'Información del contacto',
      CONTACT_INFO:
        'Al enviar este formulario y registrarte para recibir mensajes de texto, das tu consentimiento para recibir mensajes de texto de CORA Physical Therapy (por ejemplo, recordatorios de registro, información de inscripción y actualizaciones generales) de CORA Physical Therapy al número proporcionado, incluidos los mensajes enviados por marcadores automátizados. Pueden aplicarse tarifas de mensajes y datos. La frecuencia de los mensajes varía. Cancela la suscripción en cualquier momento respondiendo STOP o haciendo clic en el enlace de cancelación de suscripción (donde esté disponible). Responde HELP para obtener ayuda.',
      PRIMARY_CARE_HEADING: 'Medico de atencion primaria',
      EMERGENCY_CONTACT_HEADING: 'Contacto de emergencia',
      CONTINUE_MEDICAL_HISTORY_BUTTON: 'Continuar, al historial médico',
      PATINET_INFO: 'Información del paciente',
      FIRST_NAME_REQ: 'Se requiere el primer nombre.',
      VALID_FIRST_NAME: 'Por favor, ingrese un nombre válido',
      LAST_NAME_REQ: 'El apellido es obligatorio.',
      VALID_LAST_NAME: 'Por favor ingrese un apellido válido',
      VALID_PREFERRED_NAME: 'Ingrese un teléfono válido',
      HEIGHT_INCH_VALID: 'Ingrese una altura entre 0 y 11',
      WEIGHT_VALID: 'Por favor ingrese un peso válido',
      ZIP_REQUIRED: 'Se requiere código postal',
      ADD1_REQ: 'Se requiere la dirección 1',
      PHONE_REQ: 'Se requiere el número de teléfono',
      PHONE_VALID: 'Por favor ingrese un número de teléfono válido',
      EMAIL_VALID:
        'Ingrese la dirección de correo electrónico en el formato correcto',
      NAME_WHO_REFERRED_YOU: 'Nombre/Título de la persona que lo refirió',
      VALID_NAME: 'Por favor ingrese un nombre valido',
      NAME_REQ: 'Se requiere el nombre',
      VALID_JOB: 'Por favor ingrese un trabajo válido',
      AUTO_INSURANCE_REQ: 'Se requiere seguro de auto.',
      HEALTH_INSURANCE_REQ: 'Se requiere seguro médico.',
      CAPTURE_WEBCAMERA: 'Captura a través de la cámara web',
      CAPTURE_CAMERA: 'Captura por cámara',
      UPLOAD_FROM_PC: 'Cargar desde la unidad de su computadora',
      RETAKE: 'Volver a tomarv',
      CONT_UPLOAD_DOCS_BUTTON: 'Continuar, para subir documentos',
      UPLOADED: 'subido',
    },
    MedicalHistory: {
      MEDICAL_HISTORY: 'Historial médico',
      SKIP_TEXT: 'Omitir este paso',
      HEART_PROBLEMS: 'Problemas cardíacos',
      PREGNANT: 'Embarazada',
      CANCER: 'Cáncer',
      PACE_MAKERS: 'marcapasos',
      OSTEO: 'Osteoporosis',
      DIABETES: 'Diabetes',
      ASTHMA: 'Asma',
      STROKE: 'Apoplejía o derrame cerebrovascular',
      HIGHBP: 'Hipertensión',
      SMOKING: 'De fumar',
      SEIZURES: 'convulsiones',
      HIV_AIDS: 'VIH/SIDA',
      CHECKBOX_HEADING:
        '¿Ha tenido o tiene alguna de las siguientes afecciones o enfermedades médicas?',
      MEDICATIONS_HEADING: 'Información sobre medicamentos y alergias',
      MEDICATIONS_LABEL: 'medicamentos,',
      MEDICATIONS_PLACEHOLDER: 'Darvocet, 100 mg, cada 6 horas',
      DOYOUHAVEALLERGY: '¿Tienes alguna alergia?',
      YES: 'Sí',
      NO: 'No',
      LIST_ALLERGIES: 'Anotar Alergias *',
      CP_COMPLAINT: 'Por favor describa su principal queja física',
      CP_COMPLAINT_PLACEHOLDER: 'Queja física principal',
      HOW_WHEN_HAPPENED: 'Cómo/Cuándo sucedió',
      LAST_5YRS:
        '¿Qué otras lesiones o cirugías ha tenido en los últimos cinco años?',
      HAVE_PREVIOUS_INJURY:
        '¿Ha tenido alguna terapia previa para este problema/lesión?',
      CON_UPLOAD_DOCS_BUTTON: 'Continuar, Para Cargar Documentos',
      BACK: 'atrás',
      HELPFUL: 'Si la respuesta es afirmativa, ¿fue útil?',
      ALERGIES_REQUIRED: 'Se requieren alergias.',
    },
    MedicarePatient: {
      MEDICARE_HEADING_1:
        'A fin de determinar su elegibilidad para los servicios de terapia ambulatoria, responda las siguientes preguntas:',
      MEDICARE_HEADING_2:
        'Es un Representante de Salud en el Hogar, Enfermera, Asistente, Terapeuta o cualquiera que no sea un familiar el que ayuda actualmente en su hogar con:',
      PHYSICAL_OCCUPATIONAL_OR_SPEECH_THERAPY:
        'Terapia física, ocupacional o del habla',
      WOUND_CARE: 'Cuidado de heridas',
      INJECTIONS_OR_MEDICATIONS: 'Inyecciones o medicamentos',
      BATHING_OR_PERSONAL_CARE: 'Baño o cuidado personal',
      IV_CARE: 'cuidado intravenoso',
      HOME_HEALTH_REPRESENTATIVE:
        'Es un Representante de Salud en el Hogar, Enfermera, Asistente, Terapeuta o cualquiera que no sea un familiar el que ayuda actualmente en su hogar con servicios en los últimos 30 días',
      IF_YOU_ANS_YES:
        'Si respondió “SÍ” a cualquiera de las preguntas antes indicadas, puede QUIZÁ NO SER elegible para los servicios de terapia ambulatoria conforme se determinan por los lineamientos de Medicare. Para poder calificar para nuestros servicios, deberá recibir el alta completa de todos los servicios de atención en el hogar, los cuales son su responsabilidad. Una copia del formulario ABN de Medicare se le brinda para leer y firmar. Comprende que si los reclamos se niegan, usted es el responsable de estos gastos.',
      CONTINUE_TO_REVIEW_FORM: 'Continuar, para revisar el formulario',
      BACK: 'atrás',
      YES: 'Sí',
      NO: 'No',
    },
    UploadDocs: {
      FILE_SMALLER_THAN_25MB: 'El archivo no debe tener más de 25 MB',
      PDF_OR_IMG_ALLOWED: 'Solo puede cargar un archivo PDF o una imagen.',
      TAKE_PHOTO: 'Tomar foto',
      UPLOAD_CAPTIAL_U: 'Subir',
      UPLOAD_SMALL_U: 'subir',
      CAPTURE_WEBCAMERA: 'Captura a través de la cámara web',
      CAPTURE_CAMERA: 'Captura por cámara',
      UPLOAD_FROM_PC: 'Cargar desde la unidad de su computadora',
      RETAKE: 'Volver a tomar',
      NEXT: 'Próxima',
      SKIP: 'Saltar este paso',
      SELECT_DOC_FIRST: 'Seleccione primero el tipo de documento',
      SELECT_DOC_TYPE: 'Seleccionar tipo de documento',
      UPLOAD_TEXT: 'Estamos encantados de recoger su identificación con foto y tarjeta de seguro en la recepción si no puede subirlas. ¡Gracias!',
    },
    ReviewPage: {
      REVIEW_HEADING: 'Por favor revise sus datos',
      EDIT: 'Editar',
      PATIENT_INFORMATION: 'Información del paciente',
      LETTER_OF_EXC_COPY: 'Copia de carta de agotamiento',
      MEDICAL_INFORMATION: 'Información médica',
      MEDICARE_FORM: 'Paciente de Medicare',
      UPLOAD_DOCS: 'subir documentos',
      UPLOAD_WORD: 'Subir',
      PRESCRIPTION: 'Prescripción',
      NEXT: 'Próxima',
      BACK: 'atrás',
    },
    Signature: {
      FIELD_REQ:
        'Algunos campos son obligatorios, por favor complete y continúe',
      SIGNATURE: 'Firma',
      I_AGREE_TO_THE: 'Estoy de acuerdo con la',
      AND: 'y',
      AND_THE: 'y el',
      ACK_OF_RECEIPT:
        'acuse de recibo de notificación de prácticas de privacidad y autorización de exención',
      AUTH_CONSENT:
        'consentimiento de autorización para atención y tratamiento',
      CAUSE_OF_ACTION: 'cesión de causa de acción',
      FINANCIAL_RESP: 'responsabilidad financiera',
      T_AND_C: 'Términos y condiciones',
      PRIVACY_POLICY: 'política de privacidad',
      SUBMIT: 'Enviar',
      BACK: 'atrás',
      RECEIPT_ACK_MODAL_TEXT_PART_1:
        'Reconozco que he recibido una copia de la Notificación de Prácticas de Privacidad de Terapia Física de CORA. La Notificación de Prácticas de Privacidad describe los tipos de usos y divulgaciones de mi información de salud protegida que puede ocurrir en mi tratamiento, el pago de mis facturas o en el desempeño de las operaciones de atención de salud de Terapia Física de CORA. La Notificación de Prácticas de mis derechos y los deberes de la Terapia Física de CORA en relación con mi información de salud protegida. La Notificación de Prácticas de Privacidad está también publicada en el área De Mesa de Entradas y en el sitio en Internet de Terapia Física de CORA en www.corahealth.com. La Terapia Física de CORA se reserva el derecho de modificar las prácticas de privacidad que se describen en la Notificación de Prácticas de Privacidad. Puedo obtener una Notificación de Prácticas de Privacidad revisada al llamar al consultorio y solicitar que me envíen una copia revisada por correo, solicitando una al momento de mi próximo turno o al acceder al sitio en Internet de Terapia Física de CORA. Al hacer clic en el cuadro a continuación, usted reconoce que ha recibido o se le ha dado la oportunidad de recibir el Aviso de prácticas de privacidad de la terapia física de CORA. He recibido, o se me ha dado la oportunidad de recibir la notificacion de Practica Privada de la Terapia Fisica de Cora.',
      RECEIPT_ACK_MODAL_TEXT_PART_2:
        'AUTORIZACION PARA EL USO O DIVULGACION DE INFORMACION DE SALUD DE CORA TERAPIA FISICA',
      RECEIPT_ACK_MODAL_TEXT_PART_3:
        'Al firmar este Formulario de Autorización, comprendo que estoy brindando mi autorización a los tutores del registro médico designado de Terapia Física de CORA, a los tutores de la base de datos, al personal de la oficina de cobros y facturación central para usar y/o divulgar mi información de salud protegida (PHI), conforme se describe en más detalle en los párrafos a continuación, a las siguientes personas u organizaciones. Si esta autorización es por un motivo diferente a la divulgación de registros médicos por motivos personales, indique el objetivo de esta autorización para divulgar la PHI a continuación: Puedo revocar esta autorización en cualquier momento al avisar a la Terapia Física de CORA por escrito a la Atención del Gerente de Cobranzas, PO Box 150, Lima OH 45802 sobre mi intención de revocar esta autorización. No obstante, también comprendo que dicha revocación no tendrá efecto alguno sobre cualquier información usada o divulgada por la Terapia Física de CORA antes de que la Terapia Física de CORA reciba mi notificación escrita de revocación. A menos que se revoque anteriormente, esta autorización vencerá en el día 180 de la firma (o conforme se especifique en contrario)',
      RECEIPT_ACK_MODAL_TEXT_PART_4:
        'Yo entiendo que tengo el derecho de: Inspeccionar o copiar la INFORMACION DE SALUD PROTEGIDA para ser utilizada o divulgada según lo permitido por la ley federal o estatal; puedo negarme a firmar esta autorizacion; y recibir una copia de esta autorizacion. Si estoy solicitando información para mí o para un tercero, se puede cobrar una tarifa razonable y apropiada por copiar la información. He leído la información anterior y autorizo la divulgación de mi información por parte de CORA Terapia Fisica para el propósito descrito en este documento.',
      RECEIPT_ACK_MODAL_TEXT_PART_5:
        'Al hacer click en el cuadro a continuacion, usted reconoce que ha leido y acepta los terminos de esta autorizacion. He leído y acepto esta Autorización para el Uso o Divulgación de Información de Salud',
      TREATMENT_ACK_MODAL_TEXT:
        'Por la presente brindo mi consentimiento a la instalación y/o médicos del tratamiento y a sus agentes para divulgar todos los registros, incluso vía transmisión electrónica, preparados en el curso de mi tratamiento, a la entidad que brinde asistencia financiera para mi atención de salud, incluso, entre otras, aseguradoras y sus agentes, empleadores autoasegurados, o agencias de bienestar público. Por la presente certifico que la información presentada por mí al solicitar el pago conforme el Título XVII de la ley de seguro social es correcta. Autorizo al titular de información médica u otra información sobre mí a divulgar a la Administración de Seguro Social y/o al programa de Medicare o sus intermediarios y portadores, o a las organizaciones de revisión de normas profesionales cualquier información necesaria para este o para un reclamo relacionado de Medicare. Comprendo que al firmar este formulario, los registros de índole confidencial, como los Números de Seguro Social y aquellos para prueba de VIH, SIDA o de afección relacionada al SIDA, problemas psiquiátricos o abuso de sustancias, serán divulgados a las entidades que proveen asistencia financiera para mi atención de salud. Esta exención incluye los datos de divulgación a las entidades locales, estatales, federales u otras para fines operativos de rutina de cumplimiento regulatorio, legal o contractual, acreditación, revisión de pares, mejora de calidad, continuidad de atención o apelaciones de procesamiento para rechazos de reclamos. Asimismo, comprendo que puedo revocar este consentimiento en cualquier momento sin revocación y que vencerá un año desde esta fecha, o si se admite, a un año desde la fecha del alta. Acepto haber recibido y haber tenido la oportunidad de revisar la Información de la Instalación en relación con los derechos y las responsabilidades del paciente. Por la presente autorizo a la Terapia Física de CORA a proporcionarme atención y tratamiento bajo la instrucción de mi médico o conforme lo permita de acuerdo con las disposiciones de acceso directo de mi estado.',
      ACTION_ACK_MODAL_TEXT_1:
        'Por la presente cedo por medio de este documento todos los derechos y las causas de acción de agravio en contrato y en las leyes del estado donde estoy siendo tratado contra el asegurador de protección de lesión personal, si existe por su incumplimiento en el pago de los servicios prestados por el Cesionario en relación con mi accidente que ocurrió en',
      ACTION_ACK_MODAL_TEXT_2:
        'Llame a nuestra Oficina de Cobranzas si tiene preguntas sobre su cuenta o si no puede pagar su saldo por completo, podrán analizar con usted los acuerdos de pago. El número de teléfono es (866)-493-9410',
      FINANCIAL_ACK_MODAL_TEXT: `Comprendo que mi contrato de seguro es entre mí, mi empleador (si corresponde) y la aseguradora y la Terapia Física de CORA (CORA) no forma parte de ese contrato. Comprendo que, como asunto del proceso, CORA se comunicará con mi aseguradora (incluso Medicare) para verificar mis beneficios y los servicios cubiertos bajo mi contrato de seguro. Acepto que la provisión de un seguro exacto y otra información son clave para determinar mi elegibilidad bajo mi contrato de seguro. Comprendo que CORA está verificando beneficios como cortesía y que, por último, es mi responsabilidad comprender lo que está cubierto y lo que es obligatorio bajo mi política.

      Comprendo que CORA facturará a mi aseguradora (incluso Medicare) por los servicios prestados ante la verificación de cobertura de mi aseguradora. Comprendo que la verificación de los beneficios no es una garantía de pago y mi responsabilidad financiera está sujeta a cambios. Si mi aseguradora no presenta el pago por los servicios prestados, por la presente garantizo el pago en forma personal por los servicios y la atención médica prestada. Si mi aseguradora no remite pagos, incluso si se me niegan beneficios bajo la compensación de trabajadores, comprendo que seré responsable del saldo adeudado en su totalidad.
      
      Comprendo que soy responsable del pago de mis copagos, coseguros (incluso, coseguros de Medicare) y los deducibles al momento de servicio que acepto pueden ser un estimado en ese momento. Asimismo, comprendo que las leyes federales y estatales y los contratos de aseguradoras evitan que CORA ajuste, desgrave o renuncie a copagos, coseguros (incluso coseguros de Medicare) y deducibles. Asimismo, comprendo que soy responsable de todo saldo adeudado después del pago por mi aseguradora.
      
      Conforme la cesión de beneficios en el presente, solicito que mi aseguradora realice el pago directamente a CORA por todos los servicios prestados por esta instalación. Si mi póliza actual prohíbe el pago directo a CORA, por la presente instruyo y dirijo a mi aseguradora a realizar la salida en mi nombre pero envío el cheque a: Terapia Física de CORA (CORA Physical Therapy), PO Box 150, Lima OH 45802. Si mi aseguradora me realiza pagos, acuerdo pagarlos de inmediato sobre estos fondos a CORA. Asimismo autorizo a CORA a depositar un cheque recibido en mi cuenta cuando se realiza a mi nombre.
      
      Comprendo y acuerdo que si no cumplo con esos pagos para los cuales soy responsable de manera oportuna, seré responsable de todos los costos de cobrar dineros adeudados, incluso los costos del tribunal, los honorarios de la agencia de cobranzas y los honorarios del abogado
      `,
    },
    Submission: {
      DOXYTEXT: 'Click here to start your telehealth appointment',
      LOGOUT: 'Cerrar Sesión',
      OR: 'O',
      YOU_ARE_ALL_SET_WAYSTAR:
        'Por favor pase por la recepción para hacer el pago',
      PAYMENT: 'Haga clic aquí para proceder al pago',
      ISSUE_IN_CLINIC:
        'Hay un problema con la clínica en la que intenta registrarse.',
      FOR_MORE_INFO:
        'Para obtener más información, diríjase a la recepción o llámenos al',
      PROCEED_TO_FRONT_DESK: 'Diríjase a la recepción.',
      INFO_HAS_BEEN_SUBMITTED: 'Su información se ha enviado',
      YOU_ARE_ALL_SET: 'Pase por la recepción.',
      WE_WILL_BE_RIGHT_TO_YOU: 'Gracias. Su acuse de recibo ha sido enviado.',
      BACK_TO_HOME: 'De vuelta a casa',
    },
    VerificationOfBenefits: {
      REDO: 'Vuelva Hacer',
      SIGN_HERE: 'Firme Aquí',
      HEADING: 'Verificación de Beneficios',
      PART_1:
        'Su compañía de seguros de salud primaria ha verificado que usted tiene un',
      PART_2: 'deducible anual del cual ',
      PART_3:
        ' se ha cumplido. Después de que se haya satisfecho su deducible, su compañía de seguros estima que sus beneficios terapéuticos están cubiertos en',
      PART_4: ' Tienes una responsabilidad estimada de ',
      PART_4_5: ' o ',
      PART_5: ' debido en cada visita.',
    },
    CheckInScreening: {
      QUESTION_1:
        '¿Ha dado positivo por COVID-19 o ha experimentado alguno de los siguientes síntomas en los últimos 10 días:',
      QUESTION_1_DETAILS: `fiebre (99.5 ° o más), escalofríos, temblores repetidos con
      escalofríos, dolores musculares, secreción nasal, dolor de garganta, tos, dificultad para
      respirar, náuseas / vómitos, dolor de cabeza, dolor abdominal y / o diarrea, o nueva
      pérdida del gusto y el olfato?`,
      QUESTION_2:
        'En los últimos 10 días, ¿ha tenido contacto cercano o ha atenido a alguien que fue confirmado con COVID-19?',
      YES: 'Sí',
      NO: 'No',
      CLOSE_CONTACT_HEADER: 'El contacto cercano se define por lo siguiente:',
      CLOSE_CONTACT_1:
        'Estuvo a 6 pies de una persona infectada durante un total acumulado de 15 minutos o más durante un período de 24 horas a partir de los 2 días antes de la aparición de la enfermedad.',
      CLOSE_CONTACT_2:
        'Brindó asistencia en el hogar a alguien que está enfermo con COVID-19.',
      CLOSE_CONTACT_3:
        'Tuviste contacto físico directo con la persona (la abrazaste o la besaste).',
      CLOSE_CONTACT_4: 'Compartió utensilios para comer o beber.',
      CLOSE_CONTACT_5:
        'Estornudaron, tosieron o de alguna manera le salieron gotitas respiratorias.',
      PROCEED_TO_FRONT_DESK: 'Diríjase a la recepción.',
      CONTINUE_CHECK_IN: 'Continuar Registrarse',
    },
  },
  cr: {
    Checkin: {
      LAST_NAME: 'Non Fanmi*',
      REQ_LAST_NAME: 'Siyati obligatwa*',
      GUARD_TITLE: 'Fòmilè admisyon ranpli pa gardyen oswa lòt reprezantan legal pasyan an',
      GUARD_INFO: 'Enfòmasyon sou Gardyen an',
      RELATION_PAT: 'Relasyon ak Pasyan an obligatwa*',
      REQ_RELATION_PAT: 'Relasyon ak Pasyan an',
      SHOULD_VALID_LAST_NAME: 'non w dwe valab',
      HEADING: 'Klike pi ba pou Checkin (check-in)',
      CLINIC_ADDRESS: 'adrès klinik',
      DATE: 'Dat',
      CHECKIN_BUTTON: ' Checkin (check-in)',
      LOWER_MODEL_HEADING: ' Nou kwè nan pouvwa nan manyen pèsonèl la',
      PHYSICAL_THERAPY: 'terapi fizik',
      OCCUPATIONAL_THERAPY: 'Terapi pou kondisyon pratik',
      SPEACH_THERAPY: 'Terapi lapawòl',
      ENTER_YOUR_DETAILS: 'antre detay ou yo',
      DOB_PLACEHOLDER: 'Dat nesans ou (mm/dd/yyyy) ',
      MOBILE_PLACEHOLDER: ' nimewo telefòn',
      VALIDATE: 'Valide',
      NO_DATA_FOUND: 'Pa gin done. Tampri ale nan buro devan',
      YES: 'wi',
      NO: 'Non',
      WELCOME: 'Byenvini',
      INFO_CHANGED_TEXT: 'èske gen enfòmasyon ki chanje?',
      PHONE_NUMBER: 'nimewo telefòn',
      EMAIL: 'imel',
      ADDRESS: 'adrès',
      INSURANCE: 'Asirans',
      PLEASE_WAIT: 'Tanpri rete tann pandan nap verifye demann ou an.',
      ERROR: 'Gen yon bagay ki te pase mal. Tanpri eseye ankò pita.',
      CHECKING: 'Checkin (check-in)',
      DOB_REQUIRED: 'Dat nesans ou obligatwa',
      PHONE_REQUIRED: 'nimewo telefòn obligatwa.',
      PHONE_VALID_NUMBER: 'tanpri antre yon nimewo mobil ki valab',
    },
    PatientInformation: {
      FIRST_NAME: 'prenon*',
      LAST_NAME: ' Siyati*',
      PREFERED_NAME: 'Non prefere',
      HEIGHT_INCH: 'Wotè pous',
      HEIGHT_FEET: 'Wotè pye',
      WEIGHT: 'Pwa (lib)',
      CITY: 'Vil *',
      CITY_REQ: 'Vil obligatwa',
      STATE: ' Leta*',
      STATE_REQ: 'Eta Obligatwa',
      ZIP: 'kòd postal*',
      ADDRESS1: 'Adrès 1*',
      ADDRESS2: 'Adrès 2',
      PHONENUMBER: ' Nimewo telefòn*',
      EMAIL: ' imel*',
      HOW_DID_YOU_HEAR_ABOUT_CORA: 'Ki jan ou te tande pale de CORA',
      FROM_WHERE_DID_YOU_HEAR_ABOUT_CORA: 'Ki kote ou te tande pale de CORA?',
      PRIMARY_CARE_FIRST_NAME: 'Prenon',
      PRIMARY_CARE_LAST_NAME: 'Siyati',
      PRIMARY_CARE_PHONENUMBER: ' Nimewo telefòn ',
      EMERGENCY_CONTACT_RELATIONSHIP: 'Relasyon',
      EMERGENCY_CONTACT_FIRST_NAME: 'Prenon *',
      EMERGENCY_CONTACT_LAST_NAME: 'Siyati *',
      EMERGENCY_CONTACT_PHONENUMBER: ' Nimewo telefòn *',
      ARE_YOU_MEDICARE_PATIENT: ' èske ou se yon pasyan medicare?',
      YES: 'Wi',
      NO: 'Non',
      WHERE_DID_YOU_HAVE_THE_INCIDENT: ' Ki kote ou te fè ensidan an?',
      WORK: 'Travay',
      AUTO_ACCIDENT: 'aksidan machin',
      NEITHER: 'Ni',
      WORK_EMPLOYER_NAME: 'Non anplwayè *',
      WORK_PHONE_NUMBER: ' Nimewo telefòn ',
      WORK_CITY: 'Vil *',
      WORK_ADDRESS1: 'Adres 1',
      WORK_ADDRESS2: 'Adres 2',
      WORK_WHAT_IS_YOUR_REGULAR_JOB: 'Ki travay regilye ou?',
      WORK_STATUS_OF_JOB: 'Ki statis ou nan jòb la?',
      AUTO_ACCIDENT_INSURANCE_COMPANY: 'Konpayi asirans oto*',
      AUTO_ACCIDENT_PHONE_NUMBER: 'Nimewo telefòn',
      AUTO_ACCIDENT_ATTORNEY_PHONE_NUMBER: 'Nimewo telefòn avoka',
      AUTO_ACCIDENT_ATTORNEY_FIRST_NAME: 'Prenon avoka',
      AUTO_ACCIDENT_ATTORNEY_LAST_NAME: 'Siyati avoka',
      AUTO_ACCIDENT_HEALTH_INSURANCE_COMPANY: 'Konpayi asirans sante *',
      AUTO_ACCIDENT_HEALTH_INSURANCE_PHONE_NUMBER:
        'Nimewo telefòn asirans sante',
      AUTO_ACCIDENT_NAME_OF_PRIMARY_INSURED: 'Non asirans pwensipal ou',
      AUTO_ACCIDENT_ID_NUMBER: 'Nimewo idantifikasyon',
      AUTO_ACCIDENT_DO_YOU_HAVE_LETTER_OF_EXHUASTION:
        'Èske w gen yon lèt ki di ou konplètman fin itilize benefis yo nan konpayi asirans oto ou a?',
      AUTO_ACCIDENT_LETTER_OF_EXHUASTION_COPY:
        ' kopi lèt ki di ou konplètman fin itilize benefis yo',
      AUTO_ACCIDENT_NOT_SURE: 'Pa si',
      CONTACT_HEADER: 'Enfòmasyon kontakte',
      CONTACT_INFO:
        'Lè w soumèt fòm sa a epi enskri pou mesaj tèks, ou dakò pou resevwa mesaj tèks nan men CORA Physical Therapy (pa egzanp, rapèl enskripsyon, enfòmasyon sou enskripsyon, ak mizajou jeneral) soti nan CORA Physical Therapy nan nimewo ou bay la, ki gen ladan mesaj ki voye pa autodialer. Tarif pou mesaj ak done ka aplike. Frekans mesaj yo ka varye. Ou ka dezabòne nenpòt ki lè pa reponn STOP oswa klike sou lyen dezabònman an (lè li disponib). Reponn HELP pou èd.',
      PRIMARY_CARE_HEADING: 'Doktè swen prensipal',
      EMERGENCY_CONTACT_HEADING: 'Kontak ijans',
      CONTINUE_MEDICAL_HISTORY_BUTTON: 'Kontinye, nan istwa medikal',
      PATINET_INFO: 'Enfòmasyon pasyan',
      FIRST_NAME_REQ: 'Prenon obligatwa.',
      VALID_FIRST_NAME: 'Tanpri antre yon prenon valab',
      LAST_NAME_REQ: 'Siyati obligatwa.',
      VALID_LAST_NAME: 'Tanpri antre yon Siyati valab',
      VALID_PREFERRED_NAME: 'tanpri antre yon non prefere valab',
      HEIGHT_INCH_VALID: 'Tanpri antre wotè ou ant 0 ak 11',
      WEIGHT_VALID: 'Tanpri antre yon pwa ki valab',
      ZIP_REQUIRED: 'Kòd postal obligatwa',
      ADD1_REQ: 'Adres 1 obligatwa',
      PHONE_REQ: 'Nimewo telefòn obligatwa',
      PHONE_VALID: 'Tanpri antre yon nimewo telefòn ki valab',
      EMAIL_VALID: 'Tanpri antre yon adrès imèl nan fòma kòrèk',
      NAME_WHO_REFERRED_YOU: 'Non moun ki refere ou',
      VALID_NAME: 'Tanpri antre yon non valab',
      NAME_REQ: 'Non obligatwa',
      VALID_JOB: 'Tanpri antre yon travay ki valab',
      AUTO_INSURANCE_REQ: 'Asirans Oto obligatwa.',
      HEALTH_INSURANCE_REQ: 'Asirans Sante obligatwa.',
      CAPTURE_WEBCAMERA: 'Kaptire nan webcamera',
      CAPTURE_CAMERA: 'Kaptire pa Kamera',
      UPLOAD_FROM_PC: 'Telechaje sòti de òdinatè w lan',
      RETAKE: 'Reprann',
      CONT_UPLOAD_DOCS_BUTTON: 'Kontinye, pou voyé dokiman yo',
      UPLOADED: 'telechaje',
    },
    MedicalHistory: {
      MEDICAL_HISTORY: 'Istwa medikal',
      SKIP_TEXT: 'Sote etap sa a',
      HEART_PROBLEMS: 'Pwoblèm kè',
      PREGNANT: 'Ansent',
      CANCER: 'Kansè',
      PACE_MAKERS: 'pesmekè',
      OSTEO: 'Osteyopowoz',
      DIABETES: 'Dyabèt',
      ASTHMA: 'lasm',
      STROKE: 'Kriz tansyon',
      HIGHBP: 'Tansion',
      SMOKING: 'Fimen',
      SEIZURES: 'kriz nè',
      HIV_AIDS: 'SIDA',
      CHECKBOX_HEADING:
        'èske ou gen / ou te gen nenpòt nan maladi/enkyetid medikal sa yo?',
      MEDICATIONS_HEADING: 'Enfòmasyon medikaman ak alèji ',
      MEDICATIONS_LABEL: 'Medikaman,',
      MEDICATIONS_PLACEHOLDER: 'Darvocet, 100 mg, chak 6 èdtan',
      DOYOUHAVEALLERGY: 'èske ou gen kèk alèji?',
      YES: 'Wi',
      NO: 'Non',
      LIST_ALLERGIES: 'Ekri alèji *',
      CP_COMPLAINT: 'Tanpri dekri plent prensipal fizik ou',
      CP_COMPLAINT_PLACEHOLDER: 'plent prensipal fizik ou',
      HOW_WHEN_HAPPENED: 'Kouman /Ki lè li te rive',
      LAST_5YRS: 'Ki lòt blesi ou te genyen nan senk dènye ane yo?',
      HAVE_PREVIOUS_INJURY: 'Èske ou te gen terapi anvan pou pwoblèm nan?',
      CON_UPLOAD_DOCS_BUTTON: 'Kontinye, telechaje Dokiman yo',
      BACK: 'tounen',
      HELPFUL: 'Si repons lan se wi, li te itil?',
      ALERGIES_REQUIRED: 'Alèji yo obligatwa.',
    },
    MedicarePatient: {
      MEDICARE_HEADING_1:
        'Pou nou ka detèmine kalifikasyon ou pou sèvis terapi tanpri reponn kesyon sa yo',
      MEDICARE_HEADING_2:
        'ÈSKE YON REPREZANTAN SANTE LAKAY OU, ENFIMYÈ, ÈD, TERAPIS OSWA NENPÒT LÒT MOUN KI PA YON MANM FANMI W KOUNYE A EDE OU LAKAY OU AVÈK OU?',
      PHYSICAL_OCCUPATIONAL_OR_SPEECH_THERAPY:
        'Terapi fizik, okipasyonèl oswa terapi lapawòl?',
      WOUND_CARE: 'Swen blesu',
      INJECTIONS_OR_MEDICATIONS: 'Piki oswa medikaman',
      BATHING_OR_PERSONAL_CARE: 'Benyen oswa swen pèsonèl',
      IV_CARE: 'okipasyon sewou (IV)',
      HOME_HEALTH_REPRESENTATIVE:
        'Èske gen yon reprezantan sante lakay, Enfimyè, Èd, Terapis oswa nenpòt lòt moun ki pa yon manm fanmi ede ou lakay ou avèk sèvis nan 30 jou ki sot pase yo?',
      IF_YOU_ANS_YES:
        'Si ou reponn WI nan nenpòt nan kesyon ki anwo yo, ou ka pa kalifye pou sèvis terapi pasyan yo jan yo detèmine pa direktiv Medicare yo. Nan lòd pou kalifye pou sèvis nou yo ou pral bezwen egzeyat konplètman soti nan tout sèvis swen lakay ou, ki se responsablite ou. Yon kopi fòm Medicare ABN bay pou ou li epi siyen. Ou konprann ke si reklamasyon yo refize ou pral responsab pou akizasyon sa yo.',
      CONTINUE_TO_REVIEW_FORM: 'Kontinye, pou revize fòm',
      BACK: 'Retounen',
      YES: 'Wi',
      NO: 'Non',
    },
    UploadDocs: {
      FILE_SMALLER_THAN_25MB: ' dosye an pa ta dwe pi gran pase 25MB',
      PDF_OR_IMG_ALLOWED:
        ' Ou ka sèlman telechaje yon dosye PDF oswa yon imaj.',
      TAKE_PHOTO: ' Pran foto',
      UPLOAD_CAPTIAL_U: 'telechaje',
      UPLOAD_SMALL_U: 'telechaje',
      CAPTURE_WEBCAMERA: ' Kaptire nan webkamera',
      CAPTURE_CAMERA: ' Kaptire pa Kamera ',
      UPLOAD_FROM_PC: ' telechaje nan òdinatè w lan',
      RETAKE: ' Re-pran',
      NEXT: 'Pwochen',
      SKIP: ' Sote etap sa a',
      SELECT_DOC_FIRST: ' Tanpri chwazi kalite dokiman an premye ',
      SELECT_DOC_TYPE: ' chwazi kalite dokiman',
      UPLOAD_TEXT: 'Nou kontan kolekte ID foto ou ak kat asirans ou nan biwo devan an si ou pa kapab telechaje yo. Mèsi!',
    },
    ReviewPage: {
      REVIEW_HEADING: ' Tanpri revize detay ou yo ',
      EDIT: 'Edite',
      PATIENT_INFORMATION: ' Enfòmasyon paysan ',
      LETTER_OF_EXC_COPY: 'kopi lèt ki di ou konplètman fin itilize benefis yo',
      MEDICAL_INFORMATION: ' Enfòmasyon medikal ',
      MEDICARE_FORM: ' Pasyan Medicare',
      UPLOAD_DOCS: 'telechaje Dokiman yo',

      UPLOAD_WORD: 'telechaje',
      PRESCRIPTION: ' Preskripsyon',
      NEXT: 'Pwochen',
      BACK: 'Tounen',
      SELECT_DOC_TYPE: ' Chwazi Kalite Dokiman',
    },
    Signature: {
      FIELD_REQ: 'Gen kèk jaden obligatwa, tanpri ranpli epi kontinye',
      SIGNATURE: ' Siyati',
      I_AGREE_TO_THE: ' Mwen dakò ak',
      AND: ' E',
      AND_THE: ' E ',
      ACK_OF_RECEIPT:
        ' rekonesans pou resevwa avi sou pratik sou konfidansyalite ak otorizasyon ',
      AUTH_CONSENT: 'otorizasyon konsantman pou swen ak tretman',
      CAUSE_OF_ACTION: 'asiyasyon kòz aksyon',
      FINANCIAL_RESP: 'responsablite finansye',
      T_AND_C: 'tèm ak kondisyon',
      PRIVACY_POLICY: 'Kontra privé',
      SUBMIT: 'Soumèt',
      BACK: 'Tounen',
      RECEIPT_ACK_MODAL_TEXT_PART_1:
        'Mwen sètifye mwen te resevwa yon kopi Avi sou Pratik Konfidansyalite CORA Physical Therapy. Avi sou Pratik Konfidansyalite a dekri kalite itilizasyon ak divilgasyon enfòmasyon sante pwoteje mwen yo ki ka rive nan tretman mwen, nan peman bòdwo mwen yo oswa nan pèfòmans operasyon swen sante CORA Physical Therapy. Avi sou Pratik Konfidansyalite a dekri tou dwa mwen ak devwa CORA Physical Therapy anrapò ak enfòmasyon sante mwen pwoteje. Avi sou Pratik Konfidansyalite yo afiche tou nan zòn Resepsyon an ak sou sit entènèt CORA Physical Therapy nan www.coraphysicaltherapy.com. CORA Physical Therapy rezève dwa pou chanje pratik konfidansyalite ki dekri nan Avi sou Pratik Konfidansyalite yo. Mwen ka jwenn yon Avi sou Pratik Konfidansyalite revize lè m rele biwo a epi mande pou yo voye yon kopi revize pa lapòs, pou m mande youn nan moman pwochen randevou mwen an oswa pou m jwenn aksè nan sitwèb CORA Physical Therapy. Lè w klike sou kare ki anba a, ou rekonèt ou te resevwa oswa yo te ba w nenpòt opòtinite pou w resevwa Avi sou Pratik Konfidansyalite pou CORA Physical Therapy. yo te resevwa oswa yo te bay yon opòtinite pou resevwa Avi sou Pratik Konfidansyalite CORA Physical Therapy.',
      RECEIPT_ACK_MODAL_TEXT_PART_2:
        'OTORIZASYON POU ITILIZE OSWA DIVILGASYON INORMASYON SANTE NAN CORA PHYSICAL THERAPY',
      RECEIPT_ACK_MODAL_TEXT_PART_3:
        ' Lè ou siyen fòm Otorizasyon sa a, Mwen konprann ke mwen bay otorizasyon mwen an CORA Physical Therapy ki deziyen gadyen dosye medikal, gadyen baz done, bòdwo santral / koleksyon biwo pou itilize ak/ oswa divilge enfòmasyon sou sante pwoteje mwen (PHI), jan sa dekri an plis detay nan paragraf ki anba a, nan moun sa yo (yo) oswa òganizasyon (yo). Si otorizasyon sa a se pou nenpòt ki objektif lòt pase liberasyon an nan dosye medikal pou rezon pèsonèl, tanpri deklare objektif otorizasyon an pou lage PHI anba a: Mwen ka revoke otorizasyon sa a nenpòt ki lè lè mwen avize CORA Physical Therapy alekri nan atansyon Manadjè Koleksyon Atansyon, P.O. Box 150, Lima, OH 45802 de entansyon mwen pou revoke otorizasyon sa a. Sepandan, mwen konprann tou ke yon revokasyon konsa pa pral gen okenn efè sou nenpòt enfòmasyon ki deja itilize oswa divilje pa CORA Physical Therapy anvan CORA Terapi fizik cora te resevwa avi ekri mwen an nan revokasyon. Sòf si pi bonè revoke, otorizasyon sa a pral ekspire nan jou 180 la nan siyati a (oswa kòm otreman espesifye). ',
      RECEIPT_ACK_MODAL_TEXT_PART_4:
        'Mwen konprann mwen gen dwa pou: enspekte oswa kopye PHI pou itilize oswa divilge jan lalwa Federal oswa Eta a pèmèt; refize siyen otorizasyon sa a; epi resevwa yon kopi otorizasyon sa a. Si m ap mande enfòmasyon pou tèt mwen oswa pou yon twazyèm pati, yo ka evalye yon frè rezonab ak apwopriye pou kopi enfòmasyon an. Mwen te li enfòmasyon ki anwo yo epi mwen otorize divilgasyon enfòmasyon mwen yo pa CORA Physical Therapy pou objektif ki dekri la a.',
      RECEIPT_ACK_MODAL_TEXT_PART_5:
        'Lè w klike sou kare ki anba a, ou rekonèt ou te li epi ou dakò ak kondisyon otorizasyon sa a.',
      TREATMENT_ACK_MODAL_TEXT:
        " Pa sa mwen bay konsantman mwen nan etablisman an ak / oswa trete doktè yo ak ajan yo lage tout dosye, ki gen ladan atravè transmisyon elektwonik, prepare nan kou a nan tretman mwen an, nan nenpòt ki antite ki bay asistans finansye pou swen sante mwen, ki gen ladan, men pa limite a, konpayi asirans ak ajan yo, patwon pwòp tèt ou-asire oswa ajans byennèt piblik. Mwen sètifye ke enfòmasyon yo ban m 'nan aplike pou peman anba zak XVII de sekirite sosyal la kòrèk. Mwen otorize nenpòt detantè medikal oswa lòt enfòmasyon sou mwen pou lage bay Administrasyon Sekirite Sosyal ak/oswa pwogram Medicare oswa entèmedyè li yo oswa transpòtè yo, oswa nan òganizasyon revize pwofesyonèl yo nenpòt enfòmasyon ki nesesè pou sa a oswa yon reklamasyon Medicare ki gen rapò. Mwen konprann ke lè ou siyen fòm sa a, dosye yon nati konfidansyèl, tankou Nimewo Sekirite Sosyal ak moun ki pou tès VIH, sida oswa sida ki gen rapò ak sida, pwoblèm sikyatrik oswa abi sibstans, yo pral lage nan antite yo bay asistans finansye pou swen sante mwen. Liberasyon sa a gen ladan divilge done nan lokal, eta, federal, lòt antite pou objektif woutin operasyonèl regilasyon, konfòmite legal oswa kontra, akreditasyon, revizyon kanmarad, amelyorasyon bon jan kalite, kontinwite nan swen, oswa pwosesis apèl pou reklamasyon yo. Mwen konprann tou ke mwen ka revoke konsantman sa a nan nenpòt ki lè ak san revokasyon e ke li pral ekspire yon ane soti nan dat egzeyarizasyon an. Mwen rekonèt ke yo te bay mwen epi yo bay opòtinite pou revize Enfòmasyon Etablisman an konsènan dwa ak responsablite pasyan yo. Mwen otorize CORA Terapi fizik pou bay swen ak tretman anba direksyon doktè mwen oswa jan sa pèmèt anba dispozisyon aksè dirèk eta mwen an",
      ACTION_ACK_MODAL_TEXT_1:
        'Mwen bay ak enstriman sa a tout dwa ak tout kòz aksyon nan delit, nan kontra ak lwa eta kote yap trete m kont konpayi pwoteksyon blesi pèsonèl la, si genyen pou li pa peye pou sèvis moun kap bay mwen an. an relasyon ak aksidan mwen an ki te fèt sou',
      ACTION_ACK_MODAL_TEXT_2:
        'Tanpri rele Biwo Faktirasyon nou an si ou gen nenpòt kesyon sou kont ou oswa si ou pa kapab peye balans ou an antye yo pral kapab diskite sou aranjman peman avèk ou. Nimewo a se 866-493-9410',
      FINANCIAL_ACK_MODAL_TEXT: `
Mwen konprann ke kontra asirans mwen an ant mwen menm, patwon mwen (si sa aplikab) ak konpayi asirans lan e ke CORA Physical Therapy (CORA) pa yon pati nan kontra sa a.  Mwen konprann ke, kòm yon kesyon de pwosesis, CORA pral kontakte konpayi asirans mwen an (ki gen ladan Medicare) pou verifye benefis mwen yo ak sèvis yo kouvri anba kontra asirans mwen an.  Mwen rekonèt ke bay asirans egzat ak lòt enfòmasyon enpòtan pou detèmine mwen kalifikasyon anba kontra asirans mwen an.  Mwen konprann ke CORA ap verifye benefis yo kòm yon koutwazi e ke finalman se responsablite mwen pou konprann ki sa se garanti epi obligatwa dapre kontra mwen an.  Mwen konprann ke CORA pral voye bòdwo konpayi asirans mwen an (ki gen ladan Medicare) pou sèvis yo bay lè konpayi asirans mwen an verifie kouvèti asirans lan. Mwen konprann ke verifikasyon benefis se pa yon garanti peman ak responsablite finansye mwen an se sijè a chanje. Si asirans mwen an pa rive rann peman pou sèvis rann, mwen bay pèmanans pèsonèlman garanti peman pou swen medikal ak sèvis yo rann. Si konpayi asirans mwen an pa remèt peman, ki gen ladan si mwen refize benefisye de konpansasyon travayè yo, konprann ke mwen pral responsab pou balans lan nan plen. Mwen konprann ke mwen responsab pou peye ko-peman mwen, ko-asirans (ki gen ladan ko-asirans nan Medicare) ak franchiz nan moman sèvis ke mwen rekonèt ka yon estimasyon nan moman sa a. Pli lwen, mwen konprann ke lwa federal ak eta a ak kontra asirans anpeche CORA ajiste, ekri oswa renonse ko-peman, ko-asirans (ki gen ladan ko-asirans nan Medicare) ak deduktib. Mwen konprann tou ke mwen responsab pou nenpòt balans akòz apre peman pa konpayi asirans mwen an. Dapre plasman benefis yo isit la; Mwen demann ke asirans mwen an fè peman dirèkteman nan CORA pou tout sèvis rann pa etablisman sa a. Si règleman aktyèl mwen an entèdi peman dirèk nan COR ak dirije asirans mwen an fè chèk la soti nan non mwen, men voye chèk la nan: CORA Physical Therapy, P.O. Box 150, Lima, OH 45802. Si asirans mwen an fè peman pou mwen mwen dakò pou mwen dakò pou peye imedyatman sou lajan sa yo bay CORA. Mwen menm mwen otorize CORA pou depoze chèk mwen te resevwa sou kont mwen lè yo te fèt sou non mwen. Mwen konprann e dakò ke si mwen pa fè okenn nan peman yo pou ki mwen responsab nan yon fason apwopriye, mwen pral responsab pou tout frè kolekte lajan yo dwe, ki gen ladan depans tribinal, frè ajans koleksyon ak frè avoka. .`,
    },
    Submission: {
      DOXYTEXT: 'Click here to start your telehealth appointment',
      LOGOUT: 'Dekonekte',
      ISSUE_IN_CLINIC: 'Gen yon pwoblèm ak klinik ou ap eseye tcheke nan.',
      FOR_MORE_INFO:
        'Pou plis enfòmasyon, tanpri ale nan resepsyon an oswa rele nou nan',
      PROCEED_TO_FRONT_DESK: 'Tanpri ale nan resepsyon an',
      INFO_HAS_BEEN_SUBMITTED: 'Enfòmasyon ou yo te soumèt',
      YOU_ARE_ALL_SET: 'Mèsi, nou tout pare',
      WE_WILL_BE_RIGHT_TO_YOU: 'mèsi. Yo te voye rekonesans ou.',
      BACK_TO_HOME: ' Retounen nan Kay (Home) ',
    },
    VerificationOfBenefits: {
      REDO: 'Refe',
      SIGN_HERE: 'Siyen isit la',
      HEADING: ' Verifikasyon Benefis',
      PART_1:
        ' Konpayi asirans sante prensipal ou te verifye ke ou genyen yon ',
      PART_2: ' deduktib chak ane ki ',
      PART_3:
        ' te rankontre. Apre deduktib ou an fin satisfè, asirans ou estime benefis ki ka geri ou yo kouvri nan ',
      PART_4: ' Ou gen yon estimasyon responsablite ',
      PART_4_5: ' Oubyen ',
      PART_5: ' fok ou peye chak vizit.',
    },
    CheckInScreening: {
      QUESTION_1:
        ' Èske ou teste pozitif pou COVID-19 oswa ki gen eksperyans nenpòt nan sentòm sa yo nan dènye 10 jou yo:',
      QUESTION_1_DETAILS: ` Fyèv (99.5° oswa pi wo), frison, Misk/ Kò fèmal, Nen kap koule/ konjesyon,
      Gòj fè mal, Tous, Souf kout/ Difikilte pou respire, kè plen/vomisman, mal tèt,
      diare, Fatig, oswa nouvo pèt gou ak pran sant?`,
      QUESTION_2:
        ' Nan dènye 10 jou yo ou te gen kontak pwòch avèk oswa pran swen yon moun ki te konfime COVID-19?',
      YES: 'Wi',
      NO: 'Non',
      CLOSE_CONTACT_HEADER: ' definisyon Kontak pwòch se:',
      CLOSE_CONTACT_1:
        'Ou te 6 pye de yon moun ki enfekte pou yon total de 15 minit oswa plis pase yon peryòd 24 èdtan kòmanse soti   nan 2 jou anvan aparisyon maladi a',
      CLOSE_CONTACT_2:
        ' Ou te bay swen lakay ou pou yon moun ki malad ak COVID-19.',
      CLOSE_CONTACT_3:
        ' Ou te gen kontak dirèk ak moun nan (anbrase oswa bo yo).',
      CLOSE_CONTACT_4: ' Ou pataje manje oswa bwason.',
      CLOSE_CONTACT_5:
        ' Yo estènye, touse, oswa yon jan kanmenm te resevwa goutlèt respiratwa sou ou.',
      PROCEED_TO_FRONT_DESK: ' Tanpri kontinye nan biwo devan an',
      CONTINUE_CHECK_IN: ' Kontinye ',
    },
    patientForm: {
      VERIFY: 'Verifye',
      INVALID_URL: ' URL ou bay la pa valab',
      SUCCESS: ' verifye',
      DANGER: ' Dat nesans pa valab, tanpri re eseye. ',
      ENTER_BIRTH: ' Tanpri antre dat nesans',
      GENDER: 'Sèks',
      MALE: 'Gason',
      FEMALE: 'Fanm',
      AMBIGUOUS: 'lòt',
      SELECT_DATE: 'Chwazi Dat',
    },
  },
};
